"use strict";
var Scorer = (function () {
    function Scorer(type) {
        this.type = type;
        this.scoreIndex = this.initScore();
    }
    Scorer.prototype.getFeatureScore = function (feature) {
        var type = this.type;
        var score = this.scoreIndex[feature];
        if (score !== undefined) {
            return { type: type, feature: feature, score: score };
        }
        return undefined;
    };
    return Scorer;
}());
exports.Scorer = Scorer;
//# sourceMappingURL=base.js.map